module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collect bg"
  }, [(_vm.prize.name) ? _c('div', {
    staticClass: "list",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.prize.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.prize && _vm.prize.product) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.UPLOAD_DOMAIN + _vm.prize.product.thumbnail + '?x-oss-process=image/resize,w_100',
      "default-src": "static/placeholder.png",
      "container": "#vux_view_box_body"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wz"
  }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(_vm.prize.product.title) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_vm._v("\n                    ￥0\n                ")]), _vm._v(" "), _c('div', [_vm._v("\n                    有效期：" + _vm._s(_vm._f("date")(_vm.prize.endTime)) + "\n                ")])])]) : _vm._e()]), _vm._v(" "), (_vm.challenge && _vm.challenge._id) ? _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "white-box"
  }, [(_vm.challenge.status == 'ongoing' && _vm.challenge.invitedCount < _vm.challenge.invitedCountNeeded) ? _c('div', [_vm._v("\n                    已邀请\n                    "), _c('span', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v(_vm._s(_vm.challenge.invitedCount))]), _vm._v(" /\n                    "), _c('span', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v(_vm._s(_vm.challenge.invitedCountNeeded))]), _vm._v("\n                    人\n                ")]) : (_vm.challenge.status == 'expired') ? _c('div', [_vm._v("\n                    活动已经过期\n                ")]) : _c('div', [_vm._v("\n                    已完成, 发货中\n                ")])])]), _vm._v(" "), (_vm.challenge.addressInfo) ? _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "white-box"
  }, [_c('div', [_c('span', [_c('i', {
    staticClass: "iconfont icon-weizhi"
  }), _vm._v("收件人：" + _vm._s(_vm.challenge.addressInfo.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.challenge.addressInfo.mobileNumber))])]), _vm._v(" "), _c('div', [_vm._v("\n                    收货地址：" + _vm._s(_vm.challenge.addressInfo.area) + " " + _vm._s(_vm.challenge.addressInfo.location) + "\n                ")])])]) : _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("选择收货地址")]), _vm._v(" "), _c('buyer-address', {
    attrs: {
      "addressInfo": _vm.addressInfo
    },
    on: {
      "changeAddressInfo": _vm.changeAddressInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('button', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.goLink
    }
  }, [_vm._v("查看海报")])])]) : (_vm.prize && _vm.prize._id && _vm.prize.status == 'ongoing') ? _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("收货地址")]), _vm._v(" "), _c('buyer-address', {
    attrs: {
      "addressInfo": _vm.addressInfo
    },
    on: {
      "changeAddressInfo": _vm.changeAddressInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("昵称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                这是" + _vm._s(_vm.nickname) + "想要的0元好礼，赶快扫描二维码，关注生活道，帮他达成心愿吧。\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('button', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.genLink
    }
  }, [_vm._v("生成海报")])])]) : _c('div', [_c('div', {
    staticClass: "list"
  }, [_vm._v("活动已经结束")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9074d1a4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/invite/prize.vue
// module id = 603
// module chunks = 0